import { GAEventAction } from './GAEventAction';
import { SystemEvents } from './gameEvents';

export const GAEmailGatherActions: Map<string, GAEventAction> = new Map([
    ['GOOGLE', GAEventAction.CLICK_SOCIAL_LOGIN_GOOGLE],
    ['EMAIL', GAEventAction.CLICK_SOCIAL_LOGIN_EMAIL],
    ['FACEBOOK', GAEventAction.CLICK_SOCIAL_LOGIN_FACEBOOK]
]);

export const WebEmailGatherActions: Map<string, SystemEvents> = new Map([
    ['GOOGLE', SystemEvents.CLICK_SOCIAL_LOGIN_GOOGLE],
    ['EMAIL', SystemEvents.CLICK_SOCIAL_LOGIN_EMAIL],
    ['FACEBOOK', SystemEvents.CLICK_SOCIAL_LOGIN_FACEBOOK]
]);
